import React from "react"

const RightIcon = ({
  color,
  width = "7",
  height = "11",
}: {
  color?: string
  width?: string
  height?: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.19751 10.12L5.00084 6.3167C5.45001 5.86754 5.45001 5.13254 5.00084 4.68337L1.19751 0.880035"
        stroke={color || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RightIcon
